import EmailResponseView from './EmailResponseView';
import SmsResponseView from './SmsResponseView';
import TextResponseView from './TextResponseView';

export default {
  'EMAIL': EmailResponseView,
  'SMS': SmsResponseView,
  'TEXT': TextResponseView,
};

